import { baseUrl } from './request'
window.statistic = { router: [], axios: [], token: null, exitTime: null }
// 用来记录路由跳转数据
// window.statistic.router = []
// 用来记录异步请求记录
// window.statistic.axios = []

// 浏览器关闭或者刷新会触发此事件
// window.onunload = () => {
//   const url = baseUrl + 'statistic'
//   // console.log(url)

//   const xhr = new XMLHttpRequest()
//   xhr.onreadystatechange = function () {

//   }
//   try {
//     xhr.open('post', url)
//     xhr.setRequestHeader('content-type', 'application/json')
//     xhr.setRequestHeader('Authorization', sessionStorage.getItem('tokenStr') || localStorage.getItem('tokenStr'))
//     // 添加上token作为用户标识
//     window.statistic.token = sessionStorage.getItem('tokenStr') || localStorage.getItem('tokenStr')
//     // 添加上退出时间
//     window.statistic.exitTime = Date.now()
//     xhr.send(JSON.stringify(window.statistic))
//   } catch (e) {
//     // console.log(e)
//   }

//   const now = new Date()
//   while (new Date() - now < 500) { }
// }

// 往axios列表添加数据
export const addAxiosRecord = function (config) {
  if (config.method === 'post') {
    window.statistic.axios.push({ time: Date.now(), path: config.url, method: 'post', params: JSON.stringify(config.data) })
  }
  if (config.method === 'get') {
    window.statistic.axios.push({ time: Date.now(), path: config.url, method: 'get', params: JSON.stringify(config.params) })
  }
}

// 往routers列表添加数据
export const addRouterRecord = function (to) {
  window.statistic.router.push({ time: Date.now(), path: to.path, name: to.name })
}

export default {

}
